import { useState, useEffect } from "react";

const MENU_CSS = `
.mobile-menu-btn{display:none;background:transparent;border:1px solid var(--border);border-radius:6px;padding:0.36rem 0.6rem;cursor:pointer;color:var(--muted);transition:all 0.18s;z-index:1;flex-direction:column;gap:4px;align-items:center;justify-content:center;width:36px;height:36px;}
.mobile-menu-btn:hover{border-color:var(--gold-dim);color:var(--gold);}
.mobile-menu-btn span{display:block;width:16px;height:1.5px;background:currentColor;border-radius:2px;transition:all 0.2s;}
.mobile-menu-btn.open span:nth-child(1){transform:translateY(5.5px) rotate(45deg);}
.mobile-menu-btn.open span:nth-child(2){opacity:0;transform:scaleX(0);}
.mobile-menu-btn.open span:nth-child(3){transform:translateY(-5.5px) rotate(-45deg);}
.mobile-overlay{display:none;position:fixed;inset:0;background:rgba(0,0,0,0.7);z-index:99;backdrop-filter:blur(4px);}
.mobile-overlay.open{display:block;}
.mobile-drawer{position:fixed;top:58px;right:0;bottom:0;width:280px;background:var(--surface);border-left:1px solid var(--border);z-index:100;transform:translateX(100%);transition:transform 0.25s cubic-bezier(0.4,0,0.2,1);overflow-y:auto;padding:1rem 0;}
.mobile-drawer.open{transform:translateX(0);}
.mobile-drawer-item{display:flex;align-items:center;gap:0.75rem;padding:0.85rem 1.5rem;font-family:var(--font-mono);font-size:0.72rem;color:var(--muted);cursor:pointer;transition:all 0.15s;border:none;background:transparent;width:100%;text-align:left;letter-spacing:0.06em;}
.mobile-drawer-item:hover{color:var(--gold);background:rgba(201,168,76,0.05);}
.mobile-drawer-item.active{color:var(--gold);background:rgba(201,168,76,0.08);border-left:2px solid var(--gold);}
.mobile-drawer-sep{height:1px;background:var(--border);margin:0.5rem 1rem;}
@media(max-width:768px){
  .mobile-menu-btn{display:flex;}
  .masthead-nav{display:none !important;}
  .masthead-tagline{display:none;}
  .masthead-badge{display:none;}
}
`;

const NAV_ITEMS = [
  { key: "dashboard",          label: "Dashboard",            emoji: "🏠" },
  { key: "platform",           label: "Platform",             emoji: "🏢" },
  { key: "billtracker",        label: "Bill Search",          emoji: "📜" },
  { key: "trackedlegislation", label: "Tracked Bills",        emoji: "📌" },
  { key: "calendar",           label: "Political Calendar",   emoji: "📅" },
  { key: "billstudio",         label: "Bill Studio",          emoji: "📋" },
  { key: "map",                label: "District Map",         emoji: "🗺" },
  { key: "directory",          label: "Directory",            emoji: "📇" },
  { key: "finance",            label: "Campaign Finance",     emoji: "💰" },
  { key: "news",               label: "News",                 emoji: "📰" },
  null,
  { key: "account",            label: "Account",              emoji: "👤" },
  { key: "home",               label: "Home",                 emoji: "⌂" },
];

export function MobileMenuCSS() {
  return <style>{MENU_CSS}</style>;
}

export default function MobileMenu({ currentPage, onNavigate }) {
  const [open, setOpen] = useState(false);

  // Close on resize to desktop
  useEffect(() => {
    const onResize = () => { if (window.innerWidth > 768) setOpen(false); };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const handleNav = (key) => {
    setOpen(false);
    onNavigate(key);
  };

  return (
    <>
      <button
        className={`mobile-menu-btn${open ? " open" : ""}`}
        onClick={() => setOpen(o => !o)}
        aria-label="Menu"
      >
        <span /><span /><span />
      </button>

      <div className={`mobile-overlay${open ? " open" : ""}`} onClick={() => setOpen(false)} />

      <div className={`mobile-drawer${open ? " open" : ""}`}>
        {NAV_ITEMS.map((item, i) => {
          if (!item) return <div key={i} className="mobile-drawer-sep" />;
          return (
            <button
              key={item.key}
              className={`mobile-drawer-item${currentPage === item.key ? " active" : ""}`}
              onClick={() => handleNav(item.key)}
            >
              <span>{item.emoji}</span>
              <span>{item.label}</span>
            </button>
          );
        })}
      </div>
    </>
  );
}
